import { HTMLProps, forwardRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

const styles = () =>
  createStyles({
    root: {},
  });

export interface SidebarSectionActionProps
  extends HTMLProps<HTMLDivElement>,
    WithStyles<typeof styles> {}

const SidebarSectionAction = forwardRef<
  HTMLDivElement,
  SidebarSectionActionProps
>((props, ref) => {
  const { className, classes, children, ...rest } = props;

  return (
    <div
      {...rest}
      ref={ref}
      // keep for compatibility with existing e2e tests
      data-testid="action-button"
      className={classNames(className, classes.root)}
    >
      {children}
    </div>
  );
});

SidebarSectionAction.displayName = 'SidebarSection.Action';

export default withStyles(styles)(SidebarSectionAction);
